import { render, staticRenderFns } from "./ProductShippingConfig.vue?vue&type=template&id=56494e85&scoped=true&"
import script from "./ProductShippingConfig.vue?vue&type=script&lang=js&"
export * from "./ProductShippingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56494e85",
  null
  
)

export default component.exports